<template>
    <div>
        <b-container class="pt-2 subscription-details" fluid v-if="subscriptionDetails && subscriptionDetails.id">
            <b-row>
                <b-col md="4">
                    <div class="d-flex">
                        <div class="property-name"><b>Package:</b></div>
                        <div v-if="subscriptionDetails.status !== 'TRIAL'">
                            {{ subscriptionDetails.package.name }}
                        </div>
                        <span
                            class="clickable-field text-primary"
                            @click="isChangePackage = true"
                            v-else-if="showPackageChoice && !isChangePackage"
                        >
                            {{ subscriptionDetails.package.name }}
                        </span>
                        <div v-if="showPackageChoice && isChangePackage" class="d-flex align-items-center">
                            <form-select
                                :options="packageСhoices"
                                v-model="selectedPackage"
                                class="mb-0 mr-1 package-choices-select"
                            />
                            <b-button variant="primary" class="mr-1" @click="changePackage">
                                <font-awesome-icon :icon="['fas', 'check']" />
                            </b-button>
                            <b-button variant="danger" @click="cancelPackageChanges">
                                <font-awesome-icon :icon="['fas', 'xmark']" />
                            </b-button>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Status:</b></div>
                        <div>{{ subscriptionDetails.status }}</div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Signup Date:</b></div>
                        <div>{{ formatDate(subscriptionDetails.started) }}</div>
                    </div>
                    <div v-if="details" class="d-flex">
                        <div class="property-name"><b>Last Login Date:</b></div>
                        <div>
                            {{ formatDate(details.client.user.last_login) }}
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Billing Date:</b></div>
                        <div>
                            {{ formatDate(subscriptionDetails.next_billing_date) }}
                        </div>
                    </div>
                    <div v-if="details" class="d-flex">
                        <div class="property-name">
                            <b
                                ><a href="javascript:void(0)" @click="$bvModal.show(resetCCAttemptsModalId)"
                                    >CC Attempts:</a
                                ></b
                            >
                        </div>
                        <div>
                            <a href="javascript:void(0)" @click="$bvModal.show(resetCCAttemptsModalId)">{{
                                details.client.user.cc_attempts
                            }}</a>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Trial To:</b></div>
                        <div>
                            {{ formatDate(subscriptionDetails.trial_to) }}
                        </div>
                    </div>
                    <div v-if="showTrialExtend" class="d-flex">
                        <div class="property-name"><b>Trial Extend:</b></div>
                        <span v-if="!isExtendTrial" class="clickable-field text-primary" @click="isExtendTrial = true">
                            {{ selectedPeriod }}
                        </span>
                        <div v-if="showTrialExtend && isExtendTrial" class="d-flex align-items-center">
                            <form-select
                                :options="trialExtendOptions"
                                v-model="selectedPeriod"
                                class="mb-0 mr-1 package-choices-select"
                            />
                            <b-button variant="primary" class="mr-1" @click="changeTrialExtension">
                                <font-awesome-icon :icon="['fas', 'check']" />
                            </b-button>
                            <b-button variant="danger" @click="cancelTrialExtendChanges">
                                <font-awesome-icon :icon="['fas', 'xmark']" />
                            </b-button>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Coupon:</b></div>
                        <div>
                            {{ subscriptionDetails.coupon }}
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Gateway:</b></div>
                        <div>{{ subscriptionDetails.payment_gateway }}</div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Price:</b></div>
                        <div>{{ subscriptionDetails.amount }}</div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Cycles:</b></div>
                        <div>{{ subscriptionDetails.cycles_completed }}</div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Total Paid:</b></div>
                        <div>{{ subscriptionDetails.total_paid }}</div>
                    </div>
                    <div class="d-flex">
                        <div class="property-name"><b>Status:</b></div>
                        <div class="d-flex flex-column" v-if="subscriptionDetails.warnings.length > 0">
                            <div v-for="warning in subscriptionDetails.warnings" :key="warning">
                                {{ warning }}
                            </div>
                        </div>
                        <div v-else>No Warnings</div>
                    </div>
                    <b-button
                        v-if="subscriptionDetails.status !== 'CANCELLED'"
                        class="mt-2"
                        variant="warning"
                        @click="$bvModal.show(cancelSubscriptionModalId)"
                        >Cancel Subscription</b-button
                    >
                </b-col>
                <b-col md="8" class="mt-3 mt-md-0">
                    <grid
                        ref="grid"
                        :rowData="rowData"
                        :columnDefs="modulesColumnDefs"
                        :isAutoHeight="true"
                        :isSearch="false"
                        :class="{
                            'hide-grid': rowData.length === 0,
                        }"
                        :buttonToolbarClass="['d-flex', 'align-items-center', 'add-module-toolbar']"
                    >
                        <form-select
                            v-show="showModuleSelect"
                            v-model="selectedModule"
                            :options="selectOptions"
                            class="mb-0 mr-1"
                        />
                        <b-button v-show="showModuleSelect" class="mb-0" variant="primary" @click="addModule"
                            >Add Module</b-button
                        >
                    </grid>
                </b-col>
            </b-row>
            <modal :id="cancelSubscriptionModalId" title="Cancel Subscription" @ok.prevent="cancelSubscription">
                Are you sure you want to cancel Subscription?
            </modal>
            <modal :id="resetCCAttemptsModalId" title="Reset CC Attempts" @ok.prevent="resetCCAttempts">
                Are you sure you want reset subscriber CC attempts?
            </modal>
        </b-container>
        <div v-else>No subscription details.</div>
    </div>
</template>

<script>
    import FormSelect from '../../../generic/form-select/form-select.vue';
    import Modal from '../../../generic/modal/modal.vue';
    import API from '../../../../api';
    import {
        ADMIN_SUBSCRIBER_ACCOUNT_DETAILS,
        ADMIN_SUBSCRIBER_SUBSCRIPTION_DETAILS,
        SUBSCRIBER_SUBSCRIPTIONS_CANCEL_ENDPOINT,
    } from '../../../../endpoints';
    import { mapGetters, mapActions } from 'vuex';
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';
    import Grid from '../../../generic/grid/grid.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import { formatResponseError } from '../../../../utils/api';

    export default {
        name: 'SubscriptionDetails',
        components: {
            Modal,
            FormSelect,
            Grid,
            actionsCellRenderer: ActionsCellRenderer,
        },
        inject: ['userId'],
        data() {
            return {
                subscriptionDetails: null,
                selectedModule: null,
                isChangePackage: false,
                selectedPackage: null,
                packageСhoices: [],
                isExtendTrial: false,
                selectedPeriod: null,
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            ...mapGetters('adminSubscriberAccount', ['details']),
            rowData() {
                return this.subscriptionDetails && this.subscriptionDetails.modules.active;
            },
            showModuleSelect() {
                return this.selectOptions.length > 0;
            },
            selectOptions() {
                return this.subscriptionDetails
                    ? this.subscriptionDetails.modules.available.map((item) => ({
                          value: item.id,
                          text: item.name,
                      }))
                    : [];
            },
            cancelSubscriptionModalId() {
                return 'cancel-subscription-modal';
            },
            resetCCAttemptsModalId() {
                return 'reset-cc-attempts-modal';
            },
            modulesColumnDefs() {
                return [
                    {
                        field: 'name',
                        headerName: 'Module',
                        minWidth: 150,
                    },
                    {
                        field: 'amount',
                        headerName: 'Price',
                    },
                    {
                        field: '',
                        cellRenderer: 'actionsCellRenderer',
                        maxWidth: 120,
                        minWidth: 120,
                        cellClass: 'd-flex justify-content-center',
                        cellRendererParams: {
                            removeModule: async (id) => {
                                try {
                                    this.$parent.$emit('busy', true);
                                    const currentModuleName = this.rowData.find((item) => item.id === id)?.name;
                                    await API.post(
                                        `${ADMIN_SUBSCRIBER_SUBSCRIPTION_DETAILS(this.userId)}remove-module/`,
                                        {
                                            module_id: id,
                                        }
                                    );
                                    await this.fetchSubscriptionDetails();
                                    this.successToast({
                                        text: `Module ${currentModuleName} was successfully removed.`,
                                    });
                                } catch (e) {
                                    const { generic } = formatResponseError(e);
                                    if (generic) {
                                        this.errorToast({ text: generic });
                                    } else {
                                        this.errorToast({
                                            text: 'Could not remove module',
                                        });
                                    }
                                } finally {
                                    this.$parent.$emit('busy', false);
                                }
                            },
                        },
                    },
                ];
            },
            trialExtendOptions() {
                return Array.from({ length: 31 }, (v, k) => k).map((item) => ({
                    value: item,
                    text: item,
                }));
            },
            showTrialExtend() {
                return (
                    this.subscriptionDetails &&
                    (this.subscriptionDetails.status == 'TRIAL' || this.subscriptionDetails.status == 'TRIALSUSPEND')
                );
            },
            showPackageChoice() {
                return this.subscriptionDetails && this.subscriptionDetails.status == 'TRIAL';
            },
        },
        mounted() {
            (async () => {
                if (this.userId) {
                    this.$parent.$emit('busy', true);
                    await this.fetchSubscriptionDetails();
                    await this.fetchPackageChoices();
                    this.$parent.$emit('busy', false);
                }
            })();
        },
        methods: {
            ...mapActions('adminSubscriberAccount', ['fetchDetails']),
            async cancelSubscription() {
                try {
                    this.$parent.$emit('busy', true);
                    await API.patch(SUBSCRIBER_SUBSCRIPTIONS_CANCEL_ENDPOINT(this.subscriptionDetails.id));
                    await this.fetchSubscriptionDetails();
                    this.successToast({
                        text: 'Subscription was successfully canceled',
                    });
                    this.$bvModal.hide(this.cancelSubscriptionModalId);
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    if (generic) {
                        this.errorToast({ text: generic });
                    } else {
                        this.errorToast({
                            text: 'Could not cancel subscription',
                        });
                    }
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
            async addModule() {
                try {
                    this.$parent.$emit('busy', true);
                    const currentModuleName = this.selectOptions.find((item) => item.value === this.selectedModule)
                        ?.text;
                    await API.post(`${ADMIN_SUBSCRIBER_SUBSCRIPTION_DETAILS(this.userId)}add-module/`, {
                        module_id: this.selectedModule,
                    });
                    await this.fetchSubscriptionDetails();
                    this.successToast({
                        text: `Module ${currentModuleName} was successfully added.`,
                    });
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    if (generic) {
                        this.errorToast({ text: generic });
                    } else {
                        this.errorToast({ text: 'Could not add module' });
                    }
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
            async changePackage() {
                try {
                    this.$parent.$emit('busy', true);
                    await API.put(`${ADMIN_SUBSCRIBER_SUBSCRIPTION_DETAILS(this.userId)}change-package/`, {
                        package_id: this.selectedPackage,
                    });
                    await this.fetchSubscriptionDetails();
                    this.cancelPackageChanges();
                    this.successToast({
                        text: `The package was successfully changed.`,
                    });
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    if (generic) {
                        this.errorToast({ text: generic });
                    } else {
                        this.errorToast({ text: 'Could not change package' });
                    }
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
            async changeTrialExtension() {
                try {
                    this.$parent.$emit('busy', true);
                    await API.put(`${ADMIN_SUBSCRIBER_SUBSCRIPTION_DETAILS(this.userId)}change-trial-extension/`, {
                        period: this.selectedPeriod,
                    });
                    await this.fetchSubscriptionDetails();
                    this.cancelTrialExtendChanges();
                    this.successToast({
                        text: `Trial extension was successfully updated.`,
                    });
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    if (generic) {
                        this.errorToast({ text: generic });
                    } else {
                        this.errorToast({
                            text: 'Could not update trial extension',
                        });
                    }
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
            formatDate(value) {
                return value && value !== 'N/A' ? format(parseISO(value), this.userUnicodeDateFormat) : value;
            },
            async fetchSubscriptionDetails() {
                try {
                    const { data } = await API.get(ADMIN_SUBSCRIBER_SUBSCRIPTION_DETAILS(this.userId));
                    this.subscriptionDetails = data;
                    this.selectedPackage = data.package.id;
                    this.selectedPeriod = data.trial_extension?.period;
                    this.selectedModule = data.modules.available.length ? data.modules.available[0].id : null;
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                }
            },
            cancelPackageChanges() {
                this.isChangePackage = false;
                this.selectedPackage = this.subscriptionDetails.package.id;
            },
            cancelTrialExtendChanges() {
                this.isExtendTrial = false;
                this.selectedPeriod = this.subscriptionDetails.trial_extension.period;
            },
            async fetchPackageChoices() {
                try {
                    const { data } = await API.get(`${ADMIN_SUBSCRIBER_ACCOUNT_DETAILS()}packages-choices/`);
                    this.packageСhoices = data.map((item) => ({
                        value: item.id,
                        text: item.name,
                    }));
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    if (generic) {
                        this.errorToast({ text: generic });
                    } else {
                        this.errorToast({
                            text: 'Could not fetch package choices',
                        });
                    }
                }
            },
            async resetCCAttempts() {
                try {
                    this.$parent.$emit('busy', true);
                    await API.put(`${ADMIN_SUBSCRIBER_SUBSCRIPTION_DETAILS(this.userId)}reset-cc-attempts/`);
                    this.$bvModal.hide(this.resetCCAttemptsModalId);
                    await this.fetchDetails({
                        id: this.userId,
                    });
                    this.successToast({
                        text: `CC attempts successfully reset.`,
                    });
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    if (generic) {
                        this.errorToast({ text: generic });
                    } else {
                        this.errorToast({ text: 'Could not reset CC attemtps' });
                    }
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';
    .property-name {
        width: 140px;
        margin-right: 0.5rem;
        margin-bottom: 0.3rem;
    }

    .clickable-field {
        cursor: pointer;
        text-decoration: underline;
    }

    .package-choices-select {
        width: 150px;
    }

    :deep(.hide-grid) {
        .ag-root-wrapper {
            display: none;
        }

        .add-module-toolbar {
            width: 50%;
            @media (max-width: 768px) {
                width: 100%;
            }
        }
    }

    @include media-breakpoint-down(md) {
        :deep(.hide-grid) {
            .add-module-toolbar {
                width: 100%;
            }
        }
    }
</style>
